import {library, dom} from '@fortawesome/fontawesome-svg-core';

// icon set: solid
// ------------------------------------------------------------------
import {
    faMagnifyingGlass,
    faEnvelope,
    faUser,
    faUserGear,
    faRightFromBracket,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faTriangleExclamation,
    faXmark
} from '@fortawesome/pro-solid-svg-icons';

// icon set: pro regular
// ------------------------------------------------------------------
import {
    faHome
} from '@fortawesome/pro-regular-svg-icons';

library.add(
    faMagnifyingGlass,
    faEnvelope,
    faUser,
    faUserGear,
    faRightFromBracket,
    faChevronLeft,
    faChevronRight,
    faChevronDown,
    faTriangleExclamation,
    faXmark,
    faHome
);

dom.watch();
